<template>
  <span
    id="paginationSentinel"
  />
</template>

<script>
export default {
  name: 'SearchObjectListPaginationSentinel',
};
</script>
